const LocaleFiFI = {
  HeaderInnofactorLogoAlt: 'Innofactor Allekirjoitus logo',
  HeaderLogoutButtonAlt: 'Kirjaudu ulos',
  HeaderInfoButtonAlt: 'Tietoa palvelusta',

  Login: 'Tunnistaudu',
  LoginHeader: 'Kirjautuminen',
  Logout: 'Kirjaudu ulos',
  LogoutHeader: 'Uloskirjautuminen',
  
  ScsAuthenticationDisplayName:  'Toimikortti',
  EmailAuthenticationDisplayName:  'Sähköposti',
  LoginReasonDefault:  'Aloita sähköinen allekirjoitus tunnistautumalla',
  LoginReasonAdditionalAuthRequired:  'Jatka valitsemalla seuraava tunnistustapa',
  scsProcessResponseError:  'Kortinlukijaohjelmistoon ei saatu yhteyttä tai tunnistautuminen keskeytettiin. Varmista, että kortinlukijaohjelmisto on asennettu, se on käynnissä ja kortti on asetettu lukijaan. Voit käyttää \u003ca href=\'https://localhost:53952/\'\u003ekortinlukijaohjelmiston infosivua\u003c/a\u003e sen toiminnan tarkistamiseen. Jos infosivu ei aukea, kortinlukijaohjelmisto ei ole asennettu oikein tai se ei ole käynnissä.',
  scsProcessHandlingResponse:  'Kortinlukijalta saatu vastaus. Käsitellään vastausta...',
  scsProcessWaitingForResponse:  'Odotetaan vastausta kortinlukijaohjelmistolta... Seuraa kortinlukijan ohjeita.',
  NoVisibleExternalProviders:  'Tälle asiakkaalle ei ole konfiguroitu kirjautumistapoja.',
  InvalidLoginRequest:  'Virheellinen kirjautumispyyntö',

  LoginReasonInvalidScsResponse:  'Varmista, että kortinlukijaohjelmisto on asennettu, se on käynnissä ja kortti on kortinlukijassa',
  LoginReasonExpiredError:  'Kirjautuminen aikakatkaistiin',
  LoginReasonLoggedOut:  'Olet nyt kirjautunut ulos ja voit sulkea selaimen. Halutessasi voit myös tunnistautua uudestaan.',
  ScsLoginNotAllowed:  'Toimikorttitunnistautuminen ei ole käytössä tälle allekirjoituspyynnölle',
  EmailLoginNotAllowed: 'Sähköpostitunnistautuminen ei ole käytössä tälle allekirjoituspyynnölle',
  SmsLoginNotAllowed: 'Tekstiviestitunnistautuminen ei ole käytössä tälle allekirjoituspyynnölle',
  LoginReasonInvalidScsIssuerError:  'Väärän palveluntarjoajan toimikortti',
  LoginReasonUnauthorizedError:  'Et ole oikea henkilö allekirjoittamaan tätä asiakirjaa',
  LoginReasonInvalidScsResponseError:  'Ongelma kortinlukijaohjelmiston kanssa',
  LoginReasonExpired:  'Kirjaudu uudestaan',
  LoginReasonUnauthorized:  'Aloita sähköinen allekirjoitus tunnistautumalla toisella tunnuksella',
  LoginReasonInvalidScsIssuer:  'Aloita sähköinen allekirjoitus tunnistautumalla toisella tunnuksella',
  LoginReasonSigningTimeout:  'Kirjaudu uudelleen jatkaaksesi asiakirjan käsittelyä',
  LoginReasonErrorDuringLogin: 'Kirjautuminen epäonnistui. Yritä uudelleen.',

  Otp_Email_Header: 'Tunnistaudu sähköpostilla',
  Otp_Email_AuthenticationInfo: 'Saat sähköpostilla koodin, jolla voit tunnistautua. Syötä ensin sähköpostiosoite, johon allekirjoituskutsu lähetettiin.',
  Otp_Email_EnterUserIdentifier: "Sähköpostiosoite",
  Otp_Email_SendCode: 'Lähetä tunnistuskoodi',
  Otp_Email_UserIdentifierInvalid: 'Antamasi sähköpostiosoite ei täsmää sähköpostiosoitteeseen, johon allekirjoituskutsu lähetettiin. Syötä sähköpostiosoite täsmällisesti oikein ja yritä uudelleen.',
  Otp_Email_CodeSent: 'Tunnistuskoodi on lähetetty sähköpostiisi. Tarkista sähköpostisi ja syötä tunnistuskoodi alle. Mikäli sähköposti ei tule perille, odota ensin hetki ja tarkista myös roskapostikansio.',
  Otp_Email_CannotSendCodeTooSoon: 'Tunnistuskoodi on jo lähetetty. Tarkista sähköpostikansiosi. Tarkista myös roskapostikansio ja roskapostiasetukset. Voit lähettää uuden tunnistuskoodin hetken kuluttua.',
  Otp_Email_EnterCode: 'Tunnistuskoodi',
  Otp_Email_CodeInvalid : 'Tunnistuskoodi ei ole oikea. Syötä tunnistuskoodi, jonka sait sähköpostilla.',  
  Otp_Email_SubmitCode: 'Lähetä',
  
  Otp_Sms_Header: 'Tunnistaudu tekstiviestillä',
  Otp_Sms_AuthenticationInfo: 'Saat tekstiviestillä koodin, jolla voit tunnistautua. Syötä ensin matkapuhelinnumero kansainvälisessä muodossa (+358...), johon allekirjoituskutsu lähetettiin.',
  Otp_Sms_EnterUserIdentifier: "Puhelinnumero",
  Otp_Sms_SendCode: 'Lähetä tunnistuskoodi',
  Otp_Sms_UserIdentifierInvalid: 'Antamasi puhelinnumero ei täsmää puhelinnumeroon, johon allekirjoituskutsu lähetettiin. Syötä puhelinnumero täsmällisesti oikein ja yritä uudelleen.',
  Otp_Sms_CodeSent: 'Tunnistuskoodi on lähetetty puhelimeesi. Tarkista viestisi ja syötä tunnistuskoodi alle. Mikäli viesti ei tule perille, odota ensin hetki.',
  Otp_Sms_CannotSendCodeTooSoon: 'Tunnistuskoodi on jo lähetetty. Tarkista viestisi. Voit lähettää uuden tunnistuskoodin hetken kuluttua.',
  Otp_Sms_EnterCode: 'Tunnistuskoodi',
  Otp_Sms_CodeInvalid : 'Tunnistuskoodi ei ole oikea. Syötä tunnistuskoodi, jonka sait tekstiviestillä.',  
  Otp_Sms_SubmitCode: 'Lähetä',

  SkipToContent:  'Siirry sisältöön',
  LanguageSelection:  'Kielivalinta',
  
  //Login:  'Kirjautuminen',

  LogoutInProgress: 'Kirjaudutaan ulos...',

  UnauthorizedErrorHeader: 'Virhe',
  UnauthorizedErrorMessage: 'Et ole oikea henkilö allekirjoittamaan tätä asiakirjaa. Allekirjoituksen pyytäjä sallii vain tietyn henkilön allekirjoittaa asiakirja. Jos olet oikea henkilö, varmista, että olet kirjautunut oikealla tunnuksella. Jos ongelma jatkuu, ota yhteyttä allekirjoituksen pyytäjään.',

  Unauthorized: {
    IncorrectEmail: 'Et ole oikea henkilö allekirjoittamaan tätä asiakirjaa. Allekirjoituksen pyytäjä sallii vain tietyn henkilön allekirjoittaa asiakirja. Jos olet oikea henkilö, varmista, että olet kirjautunut oikealla sähköpostiosoitteella. Jos ongelma jatkuu, ota yhteyttä allekirjoituksen pyytäjään.',
    IncorrectSsn: 'Et ole oikea henkilö allekirjoittamaan tätä asiakirjaa. Allekirjoituksen pyytäjä sallii vain tietyn henkilön allekirjoittaa asiakirja. Jos olet oikea henkilö, varmista, että olet kirjautunut oikealla tunnuksella. Jos ongelma jatkuu, ota yhteyttä allekirjoituksen pyytäjään.',
    IncorrectPhone: 'Et ole oikea henkilö allekirjoittamaan tätä asiakirjaa. Allekirjoituksen pyytäjä sallii vain tietyn henkilön allekirjoittaa asiakirja. Jos olet oikea henkilö, varmista, että olet kirjautunut oikealla puhelinnumerolla. Jos ongelma jatkuu, ota yhteyttä allekirjoituksen pyytäjään.',
   },

  SignFlowNotFoundErrorMessage: 'Allekirjoituspyyntöä ei löydy. Varmista, että olet avannut allekirjoituslinkin kutsusähköpostista sellaisenaan. Allekirjoituspyyntö on myös voitu poistaa.',
  SignFlowCanceledErrorMessage: 'Tämä allekirjoituspyyntö on peruttu',
  SignFlowRejectedBySignerErrorMessage: 'Tämä allekirjoituspyyntö on keskeytetty',
  IdentityServerErrorMessage: 'Tapahtui virhe',

  LoginPrompt: 'Aloita sähköinen allekirjoitus tunnistautumalla',
  Loading: 'Ladataan',
  UserName: 'Käyttäjän nimi',

  SignTabButtonText: 'Allekirjoitus',
  AttachmentsTabButtonText: 'Liitteet',

  Document: 'Asiakirja',
  AlreadySigned: 'Asiakirja allekirjoitettu',
  FinalizedDocument: 'Sähköisesti allekirjoitettu asiakirja',
  WaitingForFinalization_Signer: 'Olet allekirjoittanut tämän asiakirjan ja se on käsiteltävänä. Käsittelyn valmistuttua näet sähköisesti allekirjoitetun asiakirjan tältä sivulta. Tämä sivu päivittyy automaattisesti, kun käsittely on tehty. Voit myös palata tälle sivulle allekirjoituskutsulinkin kautta myöhemmin.',
  WaitingForFinalization_Approver: 'Olet tarkastanut tämän asiakirjan ja se on käsiteltävänä. Käsittelyn valmistuttua näet sähköisesti allekirjoitetun asiakirjan tältä sivulta. Tämä sivu päivittyy automaattisesti, kun käsittely on tehty. Voit myös palata tälle sivulle tarkastuspyyntölinkin kautta myöhemmin.',
  WaitingForOthers_Signer: 'Olet allekirjoittanut tämän asiakirjan. Kun muut allekirjoittajat ovat allekirjoittaneet, näet sähköisesti allekirjoitetun asiakirjan tältä sivulta. Tämä sivu päivittyy automaattisesti, kun muut ovat allekirjoittaneet. Voit myös palata tälle sivulle allekirjoituskutsulinkin kautta myöhemmin.',
  WaitingForOthers_Approver: 'Olet tarkastanut tämän asiakirjan. Kun muut allekirjoittajat ovat allekirjoittaneet, näet sähköisesti allekirjoitetun asiakirjan tältä sivulta. Tämä sivu päivittyy automaattisesti, kun muut ovat allekirjoittaneet. Voit myös palata tälle sivulle tarkastuspyyntölinkin kautta myöhemmin.',
  SignFlowValidatingTitle: 'Asiakirjaa valmistellaan',
  SignFlowValidating: 'Allekirjoitettavaa asiakirjaa validoidaan. Tämä sivu päivittyy automaattisesti, kun käsittely on tehty. Voit myös palata tälle sivulle allekirjoituskutsulinkin kautta myöhemmin.',
  DownloadUnsignedDocument: 'Lataa allekirjoitettava tiedosto',
  DownloadFinalizedDocument: 'Lataa tiedosto',
  DownloadFinalizedZip: 'Lataa asiakirja liitteineen',
  RejectButtonText: 'Hylkää',
  BeginScsSigningButtonText: 'Aloita allekirjoitus',
  SignButtonText: 'Allekirjoita',
  ApproveButtonText: 'Merkitse tarkastetuksi',
  Attachments: 'Liitteet',
  NoAttachments: 'Ei liitteitä',
  Attachment: 'Liite',
  OpenAttachment: 'Avaa liite: $',
  Close: 'Sulje',

  SigningInfoHeader: 'Sähköinen allekirjoitus',
  SigningInfoSubHeader1: 'Allekirjoittaessasi palveluun tallennetaan sinusta seuraavat tiedot',
  SigningInfoSubHeader2Signers: 'Asiakirjan allekirjoittajat',
  SigningInfoSubHeader2Viewers: 'Tiedoksisaajat',
  SigningInfoSubHeader3Approvers: 'Asiakirjan tarkastajat',
  SigningInfoSubHeader3: 'Allekirjoituspyynnön tiedot',
  SigningInfoName: 'Nimi',
  SigningInfoFinnishSSN: 'Henkilötunnus',
  SigningInfoOrganisation: 'Organisaatio',
  SigningInfoRole: 'Rooli',
  SigningInfoNoName: 'Nimetön',
  SigningInfoOpenSignTab: 'Siirry asiakirjalle',
  SigningInfoInviterName: 'Pyytäjän nimi',
  SigningInfoInviterEmail: 'Pyytäjän sähköposti',
  SigningInfoInvitationMessage: 'Saateviesti',
  SigningInfoSignflowName: 'Asiakirjan nimi',
  SigningInfoStatusPending_Approver: 'Odottaa tarkastusta',
  SigningInfoStatusDone_Approver: 'Tarkastettu',
  SigningInfoStatusPending_Signer: 'Odottaa allekirjoitusta',
  SigningInfoStatusDone_Signer: 'Allekirjoittanut',
  SigningInfoRejected: 'Hylännyt',
  InfoPageUrl: 'Tietoa palvelusta ja tietojen käytöstä',

  SignDialogHeader: 'Allekirjoitus',
  SignDialogText1: 'Allekirjoita asiakirja?',
  SignDialogText2: 'Asiakirjaan tallennetaan sinusta seuraavat tiedot:',
  SignDialogField_Name: 'Nimi',
  SignDialogField_Procuration: 'Valitse allekirjoitusoikeutesi',
  SignDialogField_ProcurationRepresentative: 'Nimenkirjoitusoikeus (prokura)',
  SignDialogField_ProcurationAuthority: 'Toimivaltaoikeus',
  SignDialogField_ProcurationOther: 'Muu oikeus allekirjoittaa',
  SignDialogCancelButtonText: 'Peruuta',
  SignDialogFinishScsButtonText: 'Allekirjoita',
  SignDialogSignButtonText: 'Allekirjoita',

  ApproveDialogHeader: 'Tarkastus',
  ApproveDialogText1: 'Merkitse asiakirja tarkastetuksi?',
  ApproveDialogText2: 'Asiakirjaan tallennetaan sinusta seuraavat tiedot:',
  ApproveDialogField_Name: 'Nimi',
  ApproveDialogCancelButtonText: 'Peruuta',
  ApproveDialogFinishScsButtonText: 'Merkitse tarkastetuksi',
  ApproveDialogSignButtonText: 'Merkitse tarkastetuksi',

  ZipDialogHeader: 'Tiedostojen pakkaaminen kesken',
  ZipDialogContent: 'Allekirjoitettujen tiedostojen zip-pakettia valmistellaan vielä, tämä voi kestää hetken. Ole hyvä, ja kokeile uudelleen myöhemmin.',
  ZipDialogClose: 'Ok',

  UserIdentifierType_FinnishSSN: "Henkilötunnus",
  UserIdentifierType_SwedishSSN: "Henkilötunnus",
  UserIdentifierType_NorwegianSSN: "Henkilötunnus",
  UserIdentifierType_FinnishAuthenticatorIdentifier: "Finnish Authenticator-tunniste",
  UserIdentifierType_FinnishElectronicIdentificationNumber: "Sähköinen asiointitunnus",
  UserIdentifierType_MitIdUuid: "MitID UUID",
  UserIdentifierType_Scs: "Toimi- tai henkilökortin tunnistetiedot",
  UserIdentifierType_EidasPersonalIdentifier: "eIDAS-tunniste",
  UserIdentifierType_Email: "Sähköpostiosoite",
  UserIdentifierType_NationalSSN: "Henkilötunnus",
  UserIdentifierType_PhoneNumber: "Puhelinnumero",

  RejectDialogHeader: 'Hylkää',
  RejectDialogRejectionComment: 'Hylkäysperuste',
  RejectDialogCancelButtonText: 'Peruuta',
  RejectDialogRejectButtonText: 'Hylkää',

  SigningTimedOutText: 'Kirjaudu uudelleen jatkaaksesi asiakirjan käsittelyä.',

  SigningInProgressDialogHeader: 'Allekirjoitetaan',
  SigningInProgressDialogText: 'Asiakirjaa allekirjoitetaan...',

  SignedDialogHeader: 'Allekirjoitettu',
  SignedDialogText: 'Asiakirja allekirjoitettu',

  RejectionInProgressDialogHeader: 'Hylätään',
  RejectionInProgressDialogText: 'Asiakirjaa hylätään...',

  RejectedDialogHeader: 'Hylätty',
  RejectedDialogText: 'Asiakirja hylätty',

  SigningFailedDialogHeader: 'Allekirjoitus epäonnistui',
  RejectionFailedDialogHeader: 'Hylkääminen epäonnistui',

  InfoPageHeading: 'Tietoa allekirjoituspalvelusta',
  InfoPage: [
    { link: 'https://eur-lex.europa.eu/legal-content/FI/TXT/?uri=uriserv:OJ.L_.2014.257.01.0073.01.FIN', p: 'Innofactorin sähköisessä allekirjoituspalvelussa voi tehdä sähköisiä allekirjoituksia asiakirjoille. Allekirjoitukset voivat olla EU:n $eIDAS-asetuksen (EU) 910/2014$ mukaisia kehittyneitä tai hyväksyttyjä allekirjoituksia.' },
    { heading1: 'Henkilötietojen käyttö' },
    { p: 'Allekirjoituksen yhteydessä asiakirjaan tallennetaan allekirjoittajan nimi ja yksilöivä tunnistetieto. Yksilöivä tunnistetieto on tunnistustavasta ja allekirjoituksen vahvuudesta riippuen henkilötunnus, sähköinen asiointitunnus (SATU), toimi- tai henkilökortin yksilöivä tunnus tai sähköpostiosoite. Allekirjoituksen yhteydessä näet, mitä tietoja tallennetaan.' },
    { p: 'Yksilöivä tieto tarvitaan, jotta allekirjoitus liittyy asetuksen mukaisesti yksilöivästi allekirjoittajaan.' },
    { p: 'Allekirjoituksen pyytäjä näkee allekirjoittajien tiedot.' },
    { p: 'Allekirjoittajat voivat allekirjoitusprosessin valmistuttua ladata allekirjoitetun tiedoston, josta näkyy kaikkien allekirjoittajien nimet. Allekirjoittajat eivät näe yksilöiviä tunnistetietoja allekirjoituspalvelun kautta.'},
    { p: 'Allekirjoitukseen liittyvät tiedot ovat tallennettuna allekirjoituspalveluun niin kauan, kuin allekirjoituspyyntö on aktiivinen. Kun allekirjoituspyyntö ei ole enää aktiivinen, tiedot poistetaan allekirjoituspalvelusta.' }
  ],

  PrivacyPolicy: 'Tietosuojaseloste',
  OpenPrivacyPolicy: 'Siirry tietosuojaselosteeseen',

  InfoPageFeedbackUrlHeader: 'Palautekanava',
  OpenInfoPageFeedbackUrl: 'Siirry palautekanavaan',

  Error: 'Virhe',
  LoginErrorDescription: 'Kirjautumisessa tapahtui virhe, yritä uudelleen $tästä$.',

  ManualPage: [
    { heading1: 'Käyttöohje' },
    { p: 'Tässä on kuvattu allekirjoittamisen perustoiminnot. Kuvat ovat esimerkkejä ja voivat erota ulkonäöltään ja sisällöltään näkemästäsi.' },
    { heading2: 'Allekirjoituspalvelun avaaminen' },
    { p: 'Avaa allekirjoituspalvelu saamastasi kutsusähköpostin linkistä.' },
    { heading2: 'Tunnistautuminen' },
    { p: 'Tunnistaudu allekirjoituspalveluun valitsemalla tunnistautumistapa saatavilla olevista vaihtoehdoista.' },
    { img: 'auth_fin', alt: 'Tunnistautuminen' },
    { heading2: 'Allekirjoitusnäkymä' },
    { p: 'Onnistuneen tunnistautumisen jälkeen pääset katsomaan allekirjoitettavaa asiakirjaa sekä sen liitteitä.' },
    { p: 'Alareunan toiminnoilla voit hylätä tai allekirjoittaa asiakirjan.' },
    { p: 'Voit palata myöhemmin allekirjoitusnäkymään avaamalla kutsusähköpostin linkin uudestaan.' },
    { img: 'preview_fin', alt: 'Esikatselu' },
    { heading2: 'Allekirjoittaminen' },
    { p: 'Allekirjoita asiakirja painamalla allekirjoita. Hyväksy allekirjoitus varmistusdialogissa tai peruuta.' },
    { img: 'dialog_fin', alt: 'Allekirjoittaminen' },
    { p: 'Kun kaikki käyttäjät ovat allekirjoittaneet asiakirjan näytetään asiakirjasta allekirjoitettu versio, jonka kansilehdeltä nähdään kaikkien allekirjoittaneiden tiedot. Sähköisesti allekirjoitetun asiakirjan voi tämän jälkeen ladata sivun alareunasta.' },
    { heading2: 'Allekirjoituksen hylkääminen' },
    { p: 'Allekirjoituksen voi hylätä painamalla hylkää ja antamalla varmistusdialogissa hylkäysperusteen.' },
    { img: 'reject_fin', alt: 'Allekirjoituksen hylkääminen' },
    { heading2: 'Uloskirjautuminen' },
    { p: 'Voit kirjautua ulos oikean yläkulman ovikuvakkeella.' },
    { img: 'logout', alt: 'Uloskirjautuminen' },
  ],
  
  AccessibilityPageHeading: 'Saavutettavuusseloste',
  OpenAccessibilityStatement: 'Siirry saavutettavuusselosteeseen',

  AccessibilityPage: [
    { heading1: 'Saavutettavuusseloste' },
    { heading2: 'Palvelun saavutettavuus' },
    { p: 'Verkkopalvelu täyttää lain vaatimat A- ja AA-tason saavutettavuuskriteerit (WCAG 2.1), eikä palvelussa ole kriittisiä saavutettavuuspuutteita.' },
    { p: 'Palvelun saavutettavuutta arvioidaan jatkuvasti saavutettavuustyökalujen avulla. Saavutettavuus huomioidaan kaikkien uusien ominaisuuksien kehitystyössä.' },
    { p: 'Allekirjoituksen pyytäjä vastaa tarjoamansa allekirjoitettavan tiedostosisällön ja siihen kuuluvien liitteiden saavutettavuudesta.' },
    { heading2: 'Huomasitko puutteita saavutettavuudessa?' },
    { link: 'https://www.saavutettavuusvaatimukset.fi/fi/kayttajan-oikeudet/', p: 'Jos huomaat palvelussa saavutettavuusongelmia, ota yhteyttä allekirjoituksen pyytäjään. Yhteystiedot löydät allekirjoituspyynnön kutsuviestistä. Jos et ole tyytyväinen saamaasi vastaukseen tai viestiisi ei ole vastattu lainkaan kahden viikon aikana, $voit tehdä ilmoituksen valvontaviranomaiselle$. Viranomaisen sivulla kerrotaan tarkasti, miten ilmoituksen voi tehdä ja miten asia käsitellään.' },
    { heading3: 'Valvontaviranomaisen yhteystiedot' },
    { p: 'Liikenne- ja viestintävirasto Traficom' },
    { p: 'Digitaalisen esteettömyyden ja saavutettavuuden valvontayksikkö' },
    { link: 'https://www.saavutettavuusvaatimukset.fi/', p: '$www.saavutettavuusvaatimukset.fi$' },
    { p: 'saavutettavuus&commat;traficom.fi' }, // @intlify/unplugin-vue-i18n library throws JS error from @ character
    { p: 'puhelinnumero vaihde 029 534 5000' },
  ],

  LoginError: {
    HeaderText: 'Kirjautuminen epäonnistui',
    DefaultReason: 'Kirjautumisessa tapahtui virhe. Voit yrittää uudestaan avaamalla allekirjoituslinkin uudestaan. Mikäli virhe toistuu, poista mahdolliset lisäosat selaimesta tai yritä toisella selaimella. Varmista myös, että evästeet (keksit, cookies) ovat sallittuja. Jos ongelma ei ratkea, ota yhteyttä allekirjoituksen pyytäjään.',
  }
}
export type Translations = typeof LocaleFiFI;
export default LocaleFiFI;
